import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Image from '../../../Core/Image';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1.25rem;
  border-radius: 0.75rem;
  background: ${({ $backgroundColor }) =>
    $backgroundColor ? themeGet(`colors.${$backgroundColor}`) : 'transparent'};
  padding: 2.5rem 0.75rem;
  flex-direction: column;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    gap: 1.5rem;
    padding: 2.5rem;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
`;

export const Img = styled(Image)`
  width: 9.125rem;
  height: 4.125rem;
`;

export const Content = styled.div``;

export const Title = styled.h2``;

export const Body = styled.p`
  font-size: 1.125rem;
`;
